import React from "react"
import Cabecalho from "../Cabecalho"
import { TelefoneBloqueadosForm } from "./components/TelefoneBloqueadosForm"

export function TelefoneBloqueados() {
    return (
        <>
            <Cabecalho pagina="Telefones Bloqueados" />
            <TelefoneBloqueadosForm />
        </>
    )
}
